import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { AuthLayout } from "../../components/AuthLayout";
import { useAuth } from "../../lib/auth-context";
import { ApiError } from "../../lib/api";

export function SignIn() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [keep, setKeep] = useState(true);
  const [error, setError] = useState<string | null>(null);
  const [busy, setBusy] = useState(false);

  async function onSubmit(e: React.FormEvent) {
    e.preventDefault();
    setError(null);
    setBusy(true);
    try {
      await login(email, password, keep);
      navigate("/");
    } catch (err) {
      setError(err instanceof ApiError ? err.message : "Something went wrong");
    } finally {
      setBusy(false);
    }
  }

  return (
    <AuthLayout
      posterTitle="Your jars kept working while you were away."
      posterBody="Sign in to see what's due, what's ready, and what people you follow have been brewing."
    >
      <span className="eyebrow">Welcome back</span>
      <h2 style={{ margin: "12px 0 0", fontSize: 38, lineHeight: 1.05, letterSpacing: "-0.028em", marginLeft: "-0.055em" }}>
        Sign in
      </h2>

      <form onSubmit={onSubmit}>
        <div className="field" style={{ margin: "24px 0 16px" }}>
          <label>Email</label>
          <input className="input" style={{ minHeight: 44 }} type="email" required value={email} onChange={(e) => setEmail(e.target.value)} />
        </div>
        <div className="field" style={{ marginBottom: 8 }}>
          <label>Password</label>
          <input
            className="input"
            style={{ minHeight: 44 }}
            type="password"
            required
            value={password}
            onChange={(e) => setPassword(e.target.value)}
          />
        </div>
        <div className="spread" style={{ marginBottom: 24 }}>
          <label className="radio">
            <input type="checkbox" checked={keep} onChange={(e) => setKeep(e.target.checked)} />
            <span className="dot" />
            Keep me signed in
          </label>
        </div>
        {error && <p className="error-text">{error}</p>}
        <button className="btn btn-primary btn-block" style={{ minHeight: 48 }} disabled={busy} type="submit">
          {busy ? "Signing in…" : "Sign in"}
        </button>
      </form>

      <div className="flex-row" style={{ margin: "26px 0" }}>
        <span style={{ height: 2, background: "var(--color-divider)", flex: 1 }} />
        <span className="muted-strong" style={{ fontSize: 11, letterSpacing: "0.09em", textTransform: "uppercase" }}>
          or
        </span>
        <span style={{ height: 2, background: "var(--color-divider)", flex: 1 }} />
      </div>

      <Link to="/magic-link" className="btn btn-secondary btn-block" style={{ minHeight: 44 }}>
        Email me a link instead
      </Link>

      <p className="muted" style={{ margin: "28px 0 0", fontSize: 13.5 }}>
        New here? <Link to="/sign-up">Make an account</Link> — it takes about a minute.
      </p>
    </AuthLayout>
  );
}
